import { astronomers } from '@data/siteData';
import { Card, CardContent } from '@components/ui/Card';
import { Star, BookOpen } from 'lucide-react';

export default function AstronomersPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Astronomen & Forschung
          </h1>
          <p className="text-lg text-slate-400">
            Überblick über die Astronomen der Mannheimer Sternwarte und ihre Forschung von 1772
            bis 1880.
          </p>
        </div>

        {/* Research Periods */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-blue-600/10 rounded-lg flex items-center justify-center">
                <Star className="text-blue-400" size={20} />
              </div>
              <h2 className="text-xl font-bold text-white">18. Jahrhundert</h2>
            </div>
            <ul className="space-y-2 text-slate-300">
              <li>• Verbesserung der Fernrohre</li>
              <li>• Bestimmung der Astronomischen Einheit</li>
              <li>• Entdeckung der Eigenbewegung von Sonne und Fixsternen</li>
              <li>• Entdeckung wiederkehrender Kometen</li>
            </ul>
          </div>

          <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-purple-600/10 rounded-lg flex items-center justify-center">
                <BookOpen className="text-purple-400" size={20} />
              </div>
              <h2 className="text-xl font-bold text-white">19. Jahrhundert</h2>
            </div>
            <ul className="space-y-2 text-slate-300">
              <li>• Entwicklung der Astrophysik</li>
              <li>• Fraunhofersche Linien</li>
              <li>• Fotografie für lichtschwache Objekte</li>
            </ul>
          </div>
        </div>

        {/* Astronomers Grid */}
        <h2 className="text-2xl font-bold text-white mb-6">Die Astronomen</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {astronomers.map((astronomer, index) => (
            <Card key={index} hover>
              <CardContent className="py-4">
                <h3 className="text-white font-semibold">{astronomer.name}</h3>
                <p className="text-slate-400 text-sm">{astronomer.years}</p>
                <p className="text-blue-400 text-sm mt-1">{astronomer.role}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Instruments Note */}
        <div className="bg-amber-900/20 border border-amber-800/50 rounded-xl p-6">
          <h2 className="text-xl font-bold text-white mb-3">Originale Instrumente</h2>
          <p className="text-slate-300">
            Die originalen astronomischen Instrumente der alten Mannheimer Sternwarte befinden
            sich seit 1983 in den Sammlungen des TECHNOSEUM Landesmuseum für Technik und Arbeit
            in Mannheim.
          </p>
        </div>
      </div>
    </div>
  );
}
